// src/pages/Pricing/PayPalPage.jsx
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import { PayPalButtons, usePayPalScriptReducer } from '@paypal/react-paypal-js';
import { useNavigate } from 'react-router-dom';



const PayPalPage = () => {
    const { t } = useTranslation();
    const { user } = useAuth();
    const navigate = useNavigate();
    const [{ isPending }] = usePayPalScriptReducer();

    const paypalPlanId = process.env.REACT_APP_PAYPAL_PLAN_ID;

    if (!paypalPlanId) {
        return (
            <div className="min-h-screen bg-brand-dark flex items-center justify-center text-red-500">
                PayPal Plan ID is not configured.
            </div>
        );
    }
    
    return (
        <div className="min-h-screen bg-brand-dark flex items-center justify-center">
            <div className="max-w-md w-full p-8 bg-slate-800 rounded-lg text-center">
                <h2 className="text-2xl font-bold text-white mb-4">{t('paypal.title')}</h2>
                <p className="text-slate-400 mb-8">{t('paypal.description')}</p>

                {isPending ? (
                    <div className="h-12 flex items-center justify-center">
                        <div className="w-8 h-8 border-4 border-t-transparent border-white rounded-full animate-spin"></div>
                    </div>
                ) : (
                    <PayPalButtons
                        style={{ layout: "vertical", label: "subscribe" }}
                        createSubscription={(data, actions) => {
                            return actions.subscription.create({
                                plan_id: paypalPlanId,
                                custom_id: user.email // Pass user's email for tracking
                            });
                        }}
                        onApprove={(data, actions) => {
                            // This function is called when the subscription is successful
                            console.log("PayPal Subscription Approved:", data);
                            alert(`Subscription successful! Your Subscription ID is: ${data.subscriptionID}`);
                            // You should ideally send the subscriptionID to your backend here
                            // to verify and activate the user's subscription.
                            
                            // For now, we'll navigate the user to a success page or their account
                            navigate('/account'); // Or a dedicated success page
                        }}
                        onError={(err) => {
                            console.error("PayPal Button Error:", err);
                            alert(t('paypal.error'));
                        }}
                        onCancel={() => {
                            alert(t('paypal.cancelled'));
                        }}
                    />
                )}
                <p className="text-xs text-slate-500 mt-6">{t('paypal.secureNote')}</p>
            </div>
        </div>
    );
};

export default PayPalPage;